(function($) {
  
  
  // stx reorder 
  this.reorder = new function(){
    var self = this;
//  this.cartNotification = document.querySelector('cart-notification');
//       this.ajaxCart = document.querySelector('ajax-cart');
    this.pushQueue = function(i, data, el){

      console.log(data[i]);
      //LOW STOCK -- add as many as possible if stock is below requested ammount
      if(data[i].check_inventory){
        data[i].quantity = Math.min(parseInt(data[i].inventory), parseInt(data[i].quantity));
      }
      

      $.ajax({
        url: '/cart/add.js',
        method: 'POST',
        data: {
          quantity: data[i].quantity,
          id: data[i].id
        },
        complete: function(res){
          if(i >= data.length - 1){
            //products from queue are now added to the cart -> stop loading signal and go to cart
            el.removeClass('loading');
            
//             this.ajaxCart.renderContents(res);
            //       mini cart section render
            fetch('/?sections=ajax-cart')
            .then((response) => response.json())
            .then((data) => {
              var SectionHtml = data['ajax-cart'] ;
              document.querySelector('#cusomajax').innerHTML=SectionHtml;
             
               document.querySelector("body").classList.add("ajax-cart-open");
              setTimeout(()=>{
                         document.querySelector("#cusomajax .ajax__cart").setAttribute("open", "");
              			document.querySelector('.cart-count-bubble span').innerHTML= parseInt(document.querySelector('#cart-item-count').innerHTML.replace('items',''));
                         }, 100);
            
            
              
           
            });
          
          
            //minicart section end
            fetch('/cart.js')
            .then((response) => response.json())
            .then((cart) => {
              var count = cart.item_count;
              console.log(cart.total_price);


            });
            
            console.log("notification off");            
            return;
          }else{
            // Calls are async as required by Shopify Docs
               self.pushQueue(i+1, data, el);
          }
        }
      });
    }

    this.listen = function(){
      var el = $(this);
      var ids = el.attr('data-variant-ids').split(',');
      var productTitle = el.attr('data-product-title').split(',');
      var quantities = el.attr('data-variant-quantities').split(',');
      var inventories = el.attr('data-variant-inventories').split(',');
      var inventory_policies = el.attr('data-variant-inventory-policies').split(',');
      var inventory_trackers = el.attr('data-variant-inventory-trackers').split(',');
      ids.splice(-1, 1);
      productTitle.splice(-1, 1);
      quantities.splice(-1, 1);
      inventories.splice(-1, 1);
      inventory_policies.splice(-1, 1);
      inventory_trackers.splice(-1, 1);

      var data = [];
      for(var i=0; i<ids.length; i++){
        data.push({
          id: ids[i],
          product_title: productTitle[i],
          quantity: quantities[i],
          inventory: inventories[i],
          check_inventory: (inventory_policies[i] == "deny" && inventory_trackers[i] != "")
        });
      }
      el.addClass('loading');
      self.pushQueue(0, data, el);
    }

    this.init = function(){
      $('.reorder-btn').on('click', self.listen);
    }
  }

  $(reorder.init);
 
  
})(jQuery)